import React from 'react'
import Circulation from '../../components/Circulation/Circulation'

const circulation = () => {
	return (
		<div>
			<Circulation />
		</div>
	)
}


export default circulation